import React from 'react'
import styled from "styled-components";
import HorizontalAlign from "./horizontalAlign"
import LabelInput from "./labelInput"
import Input from "./input"
import SelectInput from "./selectInput"
import ButtonForm from "./buttonForm";

const StyledDiv = styled.div`
  width: 45%;
`

const FormLicenceCompetition = (
    {
        handleSubmit = null,
        handleChange = null,
        data = {},
        categorie = "AUCUNE",
        clubs = {},
        admin = false
    }) => {
    const token = localStorage.getItem('token')
    const url = window.location.href.split('/')
    return (
        <form onSubmit={handleSubmit}>
            <HorizontalAlign
                content={
                    <>
                        <StyledDiv>
                            <LabelInput content="Prénom" redStar={true}/>
                            <Input name="prenom" onChange={handleChange} defaultValue={data.prenom}/>
                            <LabelInput content="Nom" redStar={true}/>
                            <Input name="nom" onChange={handleChange} defaultValue={data.nom}/>
                            <LabelInput content="Date de naissance" redStar={true}/>
                            <Input name="dateNaissance" type="date" onChange={handleChange}
                                   defaultValue={(data.dateNaissance) ? new Date(data.dateNaissance).toISOString().slice(0, 10) : ""}/>
                            <LabelInput content={<span>Catégorie : <b>{categorie}</b><br/><br/></span>}/>
                            <LabelInput content="Sélection du club" redStar={true}/>
                            <SelectInput
                                defaultValue={data.idClub}
                                name="idClub"
                                onChange={handleChange}
                                content={
                                    <>
                                        <option value="none">Sélectionnez une option</option>
                                        <option value="none">Licence individuelle</option>
                                        {
                                            clubs.length > 0 && token !== "guest" ?
                                                clubs.map(club => {
                                                    return <option key={club._id} value={club._id}>{club.nom}</option>
                                                })
                                                : null
                                        }
                                    </>
                                }
                            />
                            <LabelInput content="Numéro de licence" redStar={true}/>
                            <Input name="numeroLicence" onChange={handleChange}
                                   defaultValue={data.numeroLicence} disabled={!admin}/>
                        </StyledDiv>
                        <StyledDiv>
                            <LabelInput content="Adresse" redStar={true}/>
                            <Input name="adresse" onChange={handleChange} defaultValue={data.adresse}/>
                            <LabelInput content="Ville" redStar={true}/>
                            <Input name="ville" onChange={handleChange} defaultValue={data.ville}/>
                            <LabelInput content="Code postal" redStar={true}/>
                            <Input name="codePostal" onChange={handleChange} defaultValue={data.codePostal}/>
                            <LabelInput content="Pays" redStar={true}/>
                            <Input name="pays" onChange={handleChange} defaultValue={data.pays}/>
                            <LabelInput content="Téléphone" redStar={true}/>
                            <Input name="telephone" onChange={handleChange} defaultValue={data.telephone}/>
                            <LabelInput content="Adresse mail" redStar={true}/>
                            <Input name="mail" onChange={handleChange} defaultValue={data.mail}/>
                        </StyledDiv>
                    </>
                }/>
            {url[3] === "licence" ?
                <ButtonForm name="envoyer" value="Envoyer"/>
                : null}
        </form>
    )
}

export default FormLicenceCompetition
